export function startOfMonthUTC(date: Date) {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1));
}

/**
 * Re-anchors a calendar day picked in the browser's zone to UTC midnight.
 *
 * A start date is a day, not an instant: "1 January 2020" has to reach the
 * backend as 2020-01-01T00:00:00Z whoever picks it. Date pickers hand back
 * local midnight, which is the previous UTC day for zones east of Greenwich
 * and hours into the right day for zones west of it.
 */
export function toUtcCalendarDay(date: Date) {
  return new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
}

/** Inverse of {@link toUtcCalendarDay}: the stored UTC day as local midnight. */
export function toLocalCalendarDay(date: Date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
